import { PaymentCondition } from "./PaymentCondition";

export interface PaymentStatus {
    id?: number;
    client?: string;
    client_name?: string;
    client_rut?: string;
    contact_email?: string;
    contact_phone?: string;
    payment_condition?: PaymentCondition;
    created_at?: string;
    issue_date?: string;
    status?: string;
    dispatch_program_id?: number;
}

export interface PaymentStatusDataForm {
    id?: number;
    client?: string;
    client_name?: string;
    client_rut?: string;
    contact_email?: string;
    contact_phone?: string;
    payment_condition?: string;
    created_at?: string;
    updated_at?: string;
    issue_date?: string;
    status?: string;
    status_label?: string;
    selected_status?: PaymentStatusesStatus
    statuses?: PaymentStatusesStatus[];
    dispatch_program_id?: number;
    dispatch_programs_id?: any[];
    society?: string;

    society_id?: string;
    client_id?: string;
    document?: string;
    created_user?: string;
    last_modified_user?: string;

    document_type?: string;
    service_manifest_id?: number;

    preliminary_exchange_rate_date_reference?: { value: string; label: string } | null;
    final_exchange_rate_date_reference?: { value: string; label: string } | null;
    preliminary_exchange_rate_date?: string | null;
    final_exchange_rate_date?: string | null;
    exchange_rate_date_source?: string | null;
    prelim_rate?: number | null;
    final_rate?: number | null;
    currency?: { id: number; name: string } | null;
    /** Nombre de moneda del EDP (listado) */
    currency_name?: string;
    /** Total bruto (neto + impuesto según maestro servicio) en moneda local, formateado */
    total_local_currency?: string | null;
    local_currency_amount?: number | null;
    total_amount?: number | null;

}

export interface PaymentStatusFilters {
    id?: number | '';
    dispatch_program_id?: number | '';
    client?: string;
    society?: string;
    status?: string;
    start_date?: string | null;
    end_date?: string | null;
    society_id?: string;
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface PaymentStatusCreateFilters {
    society_id?: string;
    client_id?: string;
}



export interface PaymentStatusesStatus {
    id: string;
    name?: string;
    prev?: number | string;
    next?: number | string;
}

export interface DispatchProgramItemPaymentStatus {
    id?: number;
    paymentStatusId?: number;
    dispatchProgramItemId?: number;
}

export const defaultPaymentStatusDataForm: PaymentStatusDataForm = {
    id: 0,
    preliminary_exchange_rate_date_reference: null,
    final_exchange_rate_date_reference: null,
    preliminary_exchange_rate_date: null,
    final_exchange_rate_date: null,
    exchange_rate_date_source: null,
    prelim_rate: null,
    final_rate: null,
}
